import Request from '@/library/Request';

/**
 * Specialized class extended from the Request class which checks if the response contains a redirect.
 * If it does, it will redirect to said URL and keep the loading status set to true
 */
export default class RedirectRequest extends Request {
  /**
   * Extend the onSuccess method with a redirect check
   *
   * @param response
   */
  onSuccess (response) {
    super.onSuccess();

    // If a redirect is present, go to that URL
    if (response.hasOwnProperty('redirect_to') && response.redirect_to) {
      // Keep the loader shown whilst the browser is redirecting
      this.loading = true;

      window.location.replace(response.redirect_to);
    }
  }
}
